import { render, staticRenderFns } from "./approvalEditFollowPopup.vue?vue&type=template&id=3ae2a91a&scoped=true&"
import script from "./approvalEditFollowPopup.vue?vue&type=script&lang=js&"
export * from "./approvalEditFollowPopup.vue?vue&type=script&lang=js&"
import style0 from "./approvalEditFollowPopup.vue?vue&type=style&index=0&id=3ae2a91a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae2a91a",
  null
  
)

export default component.exports